import styled from "styled-components";

const Container = styled.div`
	position: fixed;
	background:rgba(0,0,0,0.5);
	z-index:999;
	top:0;
	left:0;
	display:flex;
	align-items:center;
	justify-content:center;
	width:100%;
	height:100%;
	.body{
		position:relative;
		padding:24px 0px;
		width:100%;
		max-width:400px;
		background: #fff;
		height: 250px;
		overflow:hidden;
		border-radius:8px;
		box-shadow: 0px 2px 8px rgba(0,0,0,0.2);
		display:flex;
		flex-direction:column;
		h5{
			margin-bottom:16px;
			padding:0px 24px;
		}
		.close-modal{
			position:absolute;
			top:0px;
			right:0px;
			padding:8px;
			background:none;
			border:none;
			cursor:pointer;
			&:hover{
				opacity:.5;
			}
		}
		.label-search{
			display:flex;
			flex-direction:column;
			padding:0px 16px;
			justify-content:center;
			height:120px;
			border-bottom:1px solid rgba(0,0,0,0.05);
		}
		.container-form{
			overflow: auto;
			width:100%;
			height:100%;
		}
		form{
			display: flex;
			flex-direction: column;
			border-top: 1px solid rgba(0,0,0,0.1);
			height:100%;
		}
		form label{
			width: 100%;
			height: auto;
			padding: 16px 24px;
			cursor: pointer;
			display:flex;
			gap:16px;
			align-items:center;
			&:hover{
				background:#e7e7e7;
			}
		}
		.footer-modal{
			padding:0px 24px;
			text-align:center;
			opacity:0.7;
			a {
				text-decoration: underline;
				&:hover {
					opacity: 1;
				}
			}
		}
	}
	
`;

export default Container;

